/* eslint-disable no-param-reassign */
import { components } from "react-select";
import PropTypes from "prop-types";

const ClearIndicator = ({ className, preserveStyle, children, ...otherProps }) => {
  if (!preserveStyle) {
    // So that the default styles aren't applied, for full customization
    otherProps.getStyles = () => ({});
  }

  return (
    <components.ClearIndicator {...otherProps} className={className}>
      {children}
    </components.ClearIndicator>
  );
};

ClearIndicator.propTypes = {
  className: PropTypes.string,
  preserveStyle: PropTypes.bool,
  children: PropTypes.node,
};

ClearIndicator.defaultProps = {
  className: "",
  preserveStyle: false,
  children: null,
};

export default ClearIndicator;
